import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialSection = () => {
  const [visibleTestimonials, setVisibleTestimonials] = useState([]);

  useEffect(() => {
    // Staggered animation for testimonial cards (much slower)
    testimonials.forEach((_, index) => {
      setTimeout(() => {
        setVisibleTestimonials(prev => [...prev, index]);
      }, index * 800 + 1500); // 800ms delay between cards, starting after 1500ms
    });
  }, []);

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Glossy Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-bl from-yellow-600/5 via-transparent to-orange-600/5"></div>
      <div className="absolute top-20 left-1/4 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-1/4 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-yellow-900/30 text-yellow-300 rounded-full text-sm font-medium mb-6 border border-yellow-500/20">
            ⭐ Testimoni Klien
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Apa Kata 
            <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent"> Para Klien Kami</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Bergabunglah dengan ratusan UMKM yang telah merasakan manfaat XAI 
            dalam mengelola dan mengembangkan bisnis mereka.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => {
            const isVisible = visibleTestimonials.includes(index);
            return (
              <Card 
              key={testimonial.id}
              className={`relative group hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-1800 ease-out hover:-translate-y-3 bg-black/60 backdrop-blur-xl border border-white/10 hover:border-white/20 transform ${
                isVisible 
                  ? 'translate-x-0 opacity-100 scale-100' 
                  : `${index % 2 === 0 ? '-translate-x-20' : 'translate-x-20'} opacity-0 scale-85`
              } ${
                index === 1 ? 'md:scale-105 bg-gradient-to-br from-black/70 to-gray-900/50' : 'hover:bg-black/70'
              } before:absolute before:inset-0 before:bg-gradient-to-br before:from-white/5 before:to-transparent before:rounded-lg before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-500`}
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="absolute -top-4 left-8">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    index === 1 ? 'bg-blue-500' : 'bg-gray-600'
                  }`}>
                    <Quote className="h-4 w-4 text-white" />
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-6 mt-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>

                {/* Content */}
                <blockquote className="text-gray-300 mb-6 leading-relaxed">
                  "{testimonial.content}"
                </blockquote>

                {/* Author */}
                <div className="flex items-center space-x-4">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold ${
                    index === 0 ? 'bg-blue-500' :
                    index === 1 ? 'bg-green-500' : 'bg-purple-500'
                  }`}>
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-white">{testimonial.name}</div>
                    <div className="text-sm text-gray-400">{testimonial.company}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 md:p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Hasil yang Terukur untuk Klien Kami
            </h3>
            <p className="text-blue-100 max-w-2xl mx-auto">
              Data real dari penggunaan XAI oleh UMKM di seluruh Indonesia
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">45%</div>
              <div className="text-blue-100">Peningkatan Efisiensi</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">30%</div>
              <div className="text-blue-100">Pertumbuhan Omzet</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">24jam</div>
              <div className="text-blue-100">Waktu Setup</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;